export default __webpack_public_path__ + "static/media/Naval Gurjar.99109ad1.jpeg";